<template>
  <div class="page-wrapper-table">
    <div class="page-wrapper-table-header">

      <organization-selector
        v-if="
          !filterOrganization &&
          $currentUserCan($permissions.PERM_VIEW_ANY_ORGANIZATIONS)
        "
        @organizationChanged="
          (organizationId) => (selectedOrganization = organizationId)
        "
      />

      <base-input
        v-model="query"
        type="search"
        prepend-icon="fas fa-search"
        :placeholder="$t('COMMON.SEARCH')"
        clearable
      />

      <el-select
        :clearable="true"
        class="select-primary pagination-select"
        v-model="selectedStatus"
        :placeholder="$t('SHIPMENTS.STATUS')"
      >
        <el-option
          class="select-primary"
          :label="$t(`SHIPMENTS.STATUS`)"
          :value="null"
        >
        </el-option>
        <el-option
          v-for="item in ESTIMATION_STATUS"
          class="select-primary"
          :label="$t(`SHIPMENTS.ESTIMATIONS_STATUS_${item}`)"
          :value="item"
          :key="item"
        >
        </el-option>
      </el-select>
    </div>
    <div class="page-wrapper-table-body">
      <div class="page-wrapper-table-body-inner">
        <el-table
          class="align-items-center table-flush"
          header-row-class-name="thead-light"
          :data="estimations"
          @sort-change="sortChange"
        >
          <div class="table-loading" slot="empty" v-if="loading">
            <img src="/img/loading.gif" />
          </div>
          <el-table-column
            :label="$t('SHIPMENTS.REFERENCE_CODE')"
            prop="reference_code"
            sortable="custom"
            min-width="300"
          >
            <template v-slot="{ row }">
              <span>
                {{ row.reference_code ?? "" }}
              </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('SHIPMENTS.TOTAL')" min-width="320">
            <template v-slot="{ row }">
              <span class="text-uppercase">
                {{ $formatCurrency(row.total) }}
              </span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('SHIPMENTS.ITEMS_COUNT')" min-width="320">
            <template v-slot="{ row }">
              <span class="text-uppercase">
                {{ row.shipments.length }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('SHIPMENTS.STATUS')"
            prop="status"
            sortable="custom"
            min-width="120"
          >
            <template v-slot="{ row }">
              <estimation-status-badge-component :estimation="row" />
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('COMMON.DATE')"
            prop="created_at"
            sortable="custom"
            min-width="220"
          >
            <template v-slot="{ row }">
              {{ $formatDate(row.created_at) }}
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('COMMON.UPDATED_BY')" min-width="220">
            <template v-slot="{ row }">
              <users :users="[row.updatedBy]" />
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('COMMON.CREATED_BY')" min-width="220">
            <template v-slot="{ row }">
              <users :users="[row.createdBy]" />
            </template>
          </el-table-column>

          <el-table-column
            fixed="right" min-width="120">
            <div slot-scope="{ row }" class="table-actions">

              <el-tooltip
                content="Détails"
                placement="top"
              >
                <a
                  type="text"
                  @click="viewEstimation(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-expand-alt"></i>
                </a>
              </el-tooltip>

              <!--<el-tooltip
                content="Créer le pickup"
                placement="top"
                v-if="row.status == STATUS_CREATED"
              >
                <a
                  type="text"
                  @click="openPickupForm(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-truck"></i>
                </a>
              </el-tooltip>-->

              <el-tooltip
                content="Approuver"
                placement="top"
                v-if="row.status == STATUS_PENDING"
              >
                <a
                  type="text"
                  @click="approveEstimation(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-check"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                content="Annuler"
                placement="top"
                v-if="row.status == STATUS_PENDING"
              >
                <a
                  type="text"
                  @click="cancelEstimation(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-times"></i>
                </a>
              </el-tooltip>

              <el-tooltip
                content="Annuler le pickup"
                placement="top"
                v-if="row.status == STATUS_PICKUP"
              >
                <a
                  type="text"
                  @click="cancelPickup(row)"
                  class="table-action table-action-delete"
                  data-toggle="tooltip"
                  style="cursor: pointer"
                >
                  <i class="fal fa-times"></i>
                </a>
              </el-tooltip>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page-wrapper-table-footer">
      <p class="card-category">
        {{
          $t("COMMON.DISPLAY_FROM_X_TO_X_OF_X_ENTRIES", {
            from: total ? from + 1 : 0,
            to: to,
            of: total,
          })
        }}

        <span v-if="selectedRows.length">
          &nbsp; &nbsp;
          {{ $t("COMMON.X_LINES_SELECTED", { count: selectedRows.length }) }}
        </span>
      </p>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import { 
    ESTIMATION_STATUS,
    STATUS_CREATED,
    STATUS_CANCEL,
    STATUS_PENDING,
    STATUS_PICKUP,
 } from "@/constants/shipments";
import "sweetalert2/dist/sweetalert2.css";
import { French } from "flatpickr/dist/l10n/fr.js";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { BasePagination } from "@/components";
import "flatpickr/dist/flatpickr.css";
import OrganizationSelector from "@/components/OrganizationSelector.vue";
import blackListUsers from "../../../../../i18n/fr/blackListUsers";
import Organization from "@/components/Organization.vue";
import User from "@/components/User.vue";
import PickupForm from "@/components/Shipment/PickupForm.vue";
import {
  PICKUP_LOCATIONS,
} from "@/components/ElixioConnect/constants/shipment";
import EstimationStatusBadgeComponent from "@/components/EstimationStatusBadgeComponent";
import Users from "@/components/Users.vue";

export default {
  name: "shipment-estimation-list-table",

  components: {
    BasePagination,
    OrganizationSelector,
    //Organization,
    //User,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    PickupForm,
    EstimationStatusBadgeComponent,
    Users,
  },

  mixins: [requestErrorMixin],

  props: {
    filterOrganization: {
      type: String,
      default: null,
      description: "organization id",
    },
  },

  data() {
    return {
      query: null,
      selectedRows: [],
      sort: "-created_at",
      total: 0,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 50, 100, 500],
      },
      PICKUP_LOCATIONS,
      ESTIMATION_STATUS,
      STATUS_CREATED,
      STATUS_CANCEL,
      STATUS_PENDING,
      STATUS_PICKUP,
      estimations: [],
      loading: true,
      selectedOrganization: null,
      selectedStatus: this.filterStatus,
      showItemModal: false,
      shipments: [],
      componentKey: 0,
      pickupDefaults: {},
      pickupLocations: PICKUP_LOCATIONS,
      showPickupForm: false,
      currentGroupId: "",
      packageDetails: {
        weight : {
            unit: 'kg',
            value: '1',
        },
        packages:[
          {
              depth: '1',
              width: '13',
              length: '20',
              weight: '1',
              quantity: '1',
          }
        ]
      },
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    filterOrganization: {
      handler: "getListDebounced",
      immediate: true,
    },
    selectedStatus: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    openPickupForm(estimation) {
      this.currentGroupId = estimation.id;
      this.createPickupPackage(estimation);
      this.showPickupForm = true;
    },
    async onPickupSubmitted() {
      this.refreshData();
      this.showPickupForm = false;
    },
    refreshData(){
      this.componentKey += 1;
    },

    async getList(status = null) {
      
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
          },
          page: {
            number: this.pagination.currentPage,
            size: this.pagination.perPage,
          },
          include: "organization,createdBy,updatedBy",
        };

        if (this.filterOrganization) {
          params = {
            ...params,
            filter: { ...params.filter, organization: this.filterOrganization },
          };
        }
        if (this.selectedStatus) {
          params = {
            ...params,
            filter: { ...params.filter, status: this.selectedStatus },
          };
        }
        await this.$store.dispatch("elixioShipmentsEstimations/list", params);
        this.estimations = this.$store.getters["elixioShipmentsEstimations/list"];
        this.total = this.$store.getters["elixioShipmentsEstimations/listTotal"];
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
    createPickupPackage(estimation) {
      this.packageDetails.packages.quantity = estimation.shipments.length;
      const packages = this.packageDetails.packages || [];
      const totalWeight = packages.reduce(
        (sum, p) => sum + Number(p.weight || 0) * Number(estimation.shipments.length),
        0
      );
      const totalQuantity = packages.reduce(
        (sum, p) => sum + Number(estimation.shipments.length),
        0
      );

      this.pickupDefaults = {
        pickup_details: {
          date: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            day: new Date().getDate(),
          },
          ready_at: { hour: 9, minute: 0 },
          ready_until: { hour: 17, minute: 0 },
          package_details: {
            weight: {
              unit: this.packageDetails.weight.unit,
              value: totalWeight.toString(),
            },
            quantity: totalQuantity.toString(),
          },
          pickup_location: this.pickupLocations,
          pickup_instructions: "",
        }
      };
    },
    viewEstimation(shipmentEstimation) {
      this.$emit("onViewShipmentEstimation", shipmentEstimation);
    },

    approveEstimation(shipmentEstimation) {
      this.$emit("onApproveShipmentEstimation", shipmentEstimation);
    },
    async cancelEstimation(shipmentEstimation) {
      this.$emit("onCancelShipmentEstimation", shipmentEstimation);
    },
    async cancelPickup(shipmentEstimation) {
      this.$emit("onCancelPickup", shipmentEstimation);
    },

    sortChange({ prop, order }) {
      if (order === "descending") {
        this.sort = `-${prop}`;
      } else {
        this.sort = `${prop}`;
      }
      this.getList();
    },
  },
};
</script>
